module.exports = __webpack_public_path__ + "img/brand-empty.2c566e26.png";